export default {
  checkBind: '/api/store/precheck',
}
